import { getLang } from '@/utils/storage.js'
import { getItem } from '@/utils/storage-main'
import logo from '@/assets/images/login/logo-new.svg'
import njcbLogo from '@/assets/images/login/njcb.svg'
import mobileBg from '@/assets/images/login/login-bg-mobile.jpg'
import njcbMobileBg from '@/assets/images/login/njcbMobileBg.png'
import ZlzpLogo from '@/assets/images/login/zlzp.png'
import PorscheLogo from '@/assets/images/login/porsche.png'
import NissanLogo from '@/assets/images/login/nissan.png'
import AiahrnLogo from '@/assets/images/login/aiahrn-logo.png'
import porscheBg from '@/assets/images/login/porschebg.png'
import nissanBg from '@/assets/images/login/nissanbg.png'
import AiahrnPcbg from '@/assets/images/login/aiahrn-pcbg.png'
import cim from '@/assets/images/login/porsche-cim-logo.png'
import porsche911Bg from '@/assets/images/login/porsche911bg.png'
import porschetaycanBg from '@/assets/images/login/porschetaycanbg.png'
import njcbMeetsBg from '@/assets/images/login/njcb-meets-bg.png'
// import aiaBg from '@/assets/images/login/aiabg.png'
import i18n from '../i18n/i18n'
import takedaspark from './config/takedaspark'

const gotinAddress = (type) => {
  return `https://www.gotin.online/${getLang()}/${type}`
}

export const getBusinessSeetings = (business = 'gotin') => {
  const MockBusinessSeetings = {
    // 有大默认
    gotin: {
      title: i18n.t('login.loginPage.defaultTitle'), // 名称
      bg: mobileBg, // 背景图
      logo: '',
      id: 'gotin', // 唯一标识
      unionId: 'gotin', // 唯一id
      slogan: 'gotin', // 宣传语
      sloganFromLocal: 'welcome',
      logoUrl: logo, // logo地址
      termsOfUse: 'https://www.gotin.online/terms', // 服务条款
      signInMethods: ['phone', 'email'], // 登录方式
      signInMode: ['signIn', 'signUp'], // 注册/登录
      socialConnectors: ['wechat'], // 微信登录
      languageInfo: ['en', 'cn'], // 语言
      position: 'top', // 显示位置
      className: 'single-wrap',
      defaultContainer: 'box-container',
      isSupportRegion: true, // 是否支持区域
      needSlientLogin: true, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: false, // 是否有自己的短信服务,
      isMergeLoginAndRegister: false, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: '', // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容,
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: false, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: false, // 是否有自己的字体
      hasOwnThemeStyle: false, // 是否有自己的主题样式
      fontNames: '', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreText'), // 条款前缀
      agreeAnd: i18n.t('login.register.and'), // 条款链接符
      isNeedPassSource: false, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    // 游客与有大一致
    guest: {
      title: i18n.t('login.loginPage.defaultTitle'), // 名称
      bg: mobileBg, // 背景图
      logo: '',
      id: 'gotin', // 唯一标识
      unionId: 'gotin', // 唯一id
      slogan: 'gotin', // 宣传语
      sloganFromLocal: 'welcome',
      logoUrl: logo, // logo地址
      termsOfUse: 'https://www.gotin.online/terms', // 服务条款
      signInMethods: ['phone', 'email'], // 登录方式
      signInMode: ['signIn', 'signUp'], // 注册/登录
      socialConnectors: ['wechat'], // 微信登录
      languageInfo: ['en', 'cn'], // 语言
      position: 'top', // 显示位置
      className: 'single-wrap',
      defaultContainer: 'box-container',
      isSupportRegion: true, // 是否支持区域
      needSlientLogin: true, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: false, // 是否有自己的短信服务
      isMergeLoginAndRegister: false, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: '', // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示标题
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: false, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: false, // 是否有自己的字体
      hasOwnThemeStyle: false, // 是否有自己的主题样式
      fontNames: '', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreText'), // 条款前缀
      agreeAnd: i18n.t('login.register.and'), // 条款链接符
      isNeedPassSource: false, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    // 南京银行
    njcb: {
      title: '南京银行你好世界',
      bg: njcbMobileBg,
      logo: '',
      id: 'njcb',
      unionId: 'nanjing_bank',
      slogan: '世界',
      sloganFromLocal: 'welcomeNjcb',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'njcb',
      defaultContainer: 'njcb-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: true, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.owndesc'), // 当前登录面板的描述
      OwnTipsTitle: '点击查看南京银行', // 自己的提示内容
      OwnTipsSubTitle: '温馨提示', // 如果有提示的话，提示内容
      OwnTipsContent:
        '“你好世界”元宇宙空间是由南京银行为您打造，您注册输入的个人信息仅用于在南京银行元宇宙空间“你好世界”登录与参与活动使用，南京银行将对您的个人信息进行严格保密，不做任何其他用途，在此衷心感谢您对南京银行长期以来的关注与支持！如您需要任何帮助，请拨打南京银行统一客服热线：95302。      ', // 如果有提示的话，提示内容
      OwnMoreTips:
        '如果您已持有南京银行账户，请使用您在南京银行预留的手机号码登录。', // 是否有更多提示
      isShowRegion: false, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: false, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: false, // 是否有自己的字体
      hasOwnThemeStyle: false, // 是否有自己的主题样式
      fontNames: '', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreText'), // 条款前缀
      agreeAnd: i18n.t('login.register.and'), // 条款链接符
      isNeedPassSource: false, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    // 展商后台
    expo: {
      title: '有了gotin', // 名称
      bg: mobileBg, // 背景图
      logo: '',
      id: 'expo', // 唯一标识
      unionId: 'expo', // 唯一id
      slogan: 'gotin', // 宣传语
      sloganFromLocal: 'welcome',
      logoUrl: logo, // logo地址
      termsOfUse: 'https://www.gotin.online/terms', // 服务条款
      signInMethods: ['phone', 'email'], // 登录方式
      signInMode: ['signIn', 'signUp'], // 注册/登录
      socialConnectors: [], // 微信登录
      languageInfo: ['en', 'cn'], // 语言
      position: 'top', // 显示位置
      className: 'single-wrap',
      defaultContainer: 'box-container',
      isSupportRegion: true, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: false, // 自己平台用户登录
      isAutoLogin: false, // 是否自动登录
      hasOwnSms: false, // 是否有自己的短信服务
      isMergeLoginAndRegister: false, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: '', // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: false, // 是否需要标记来源
      hasCustomLoginPage: false, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: false, // 是否有自己的字体
      hasOwnThemeStyle: false, // 是否有自己的主题样式
      fontNames: '', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreText'), // 条款前缀
      agreeAnd: i18n.t('login.register.and'), // 条款链接符
      isNeedPassSource: false, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    // 展商活动登录
    ptexpo2022: {
      title: '有了gotin', // 名称
      bg: mobileBg, // 背景图
      logo: '',
      id: 'ptexpo2022', // 唯一标识
      unionId: 'pt', // 唯一id
      slogan: 'gotin', // 宣传语
      sloganFromLocal: 'welcome',
      logoUrl: logo, // logo地址
      termsOfUse: 'https://www.gotin.online/terms', // 服务条款
      signInMethods: ['phone', 'email'], // 登录方式
      signInMode: ['signIn', 'signUp'], // 注册/登录
      socialConnectors: [], // 微信登录
      languageInfo: ['en', 'cn'], // 语言
      position: 'top', // 显示位置
      className: 'single-wrap',
      defaultContainer: 'box-container',
      isSupportRegion: true, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: false, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: '', // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: false, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: false, // 是否有自己的字体
      hasOwnThemeStyle: false, // 是否有自己的主题样式
      fontNames: '', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreText'), // 条款前缀
      agreeAnd: i18n.t('login.register.and'), // 条款链接符
      isNeedPassSource: false, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    // 智联招聘活动登录
    zlzp: {
      title: '有了gotin', // 名称
      bg: mobileBg, // 背景图
      logo: ZlzpLogo,
      id: 'zlzp', // 唯一标识
      unionId: 'zl', // 唯一id
      slogan: 'zlzp', // 宣传语
      sloganFromLocal: 'welcomeZl',
      logoUrl: logo, // logo地址
      termsOfUse: 'https://www.gotin.online/terms', // 服务条款
      signInMethods: ['phone'], // 登录方式
      signInMode: ['signIn', 'signUp'], // 注册/登录
      socialConnectors: [], // 微信登录
      languageInfo: ['cn'], // 语言
      position: 'top', // 显示位置
      className: 'zlzp-wrap',
      defaultContainer: 'zlzp-container',
      isSupportRegion: true, // 是否支持区域
      needSlientLogin: true, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: false, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: '未注册手机号将自动为您创建账户', // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: false, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: '', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextZlzp'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPreTextZlzp'), // 条款链接符
      isNeedPassSource: false, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    // 保时捷项目
    porsche718: {
      title: '718/911登录标题',
      bg: porscheBg,
      id: 'porsche',
      logo: PorscheLogo,
      unionId: 'porsche718',
      slogan: '世界',
      sloganFromLocal: 'welcomePorsche',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'porsche-wrap',
      defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'PorscheNextTT', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    porsche911: {
      title: i18n.t('login.loginPage.titlePorsche911'),
      bg: porsche911Bg,
      id: 'porsche',
      unionId: 'porsche911',
      logo: '',
      slogan: '世界',
      sloganFromLocal: 'welcomePorsche911',
      subTitleFromLocal: 'welcomeSubPorsche911',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'porsche911-wrap',
      defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示s
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'PorscheNextTT', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'), // 条款链接符
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: true, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCodePorsche'), // 短信登录标题
    },
    // 保时捷项目
    cocafe: {
      title: '718/911登录标题',
      bg: porscheBg,
      id: 'porsche',
      logo: PorscheLogo,
      unionId: 'porsche718',
      slogan: '世界',
      sloganFromLocal: 'welcomePorsche',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'porsche-wrap',
      defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: false, // 自己平台用户登录
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.owndesc'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'PorscheNextTT', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreText'), // 条款前缀
      agreeAnd: i18n.t('login.register.and'), // 条款链接符
      isNeedPassSource: false, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    // taycan
    porschetaycan: {
      title: i18n.t('login.loginPage.titlePorscheTaycan'),
      bg: porschetaycanBg,
      id: 'porsche',
      logo: '',
      unionId: 'porschetaycan',
      slogan: '世界',
      sloganFromLocal: 'welcomePorschetaycan',
      subTitleFromLocal: 'welcomeSubPorschetaycan',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'porschetaycan-wrap',
      defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'PorscheNextTT', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: true, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCodePorsche'), // 短信登录标题
    },
    // 友邦
    aia: {
      title: '友邦游元会',
      bg: 'https://meta.gotin.online/Table/Prod/AIA/arts/AIA_login_bg.jpg',
      bgRepeat: 'no-repeat', // 背景 fix: repeat:round 造成background-size: cover失效，图片拉伸
      id: 'aia',
      logo: '',
      unionId: 'aia',
      slogan: '世界',
      sloganFromLocal: 'welcomePorschetaycan',
      subTitleFromLocal: 'welcomeSubPorschetaycan',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'aia-wrap',
      // defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: false, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: false, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'simhei_aia', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: true, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCodePorsche'), // 短信登录标题
    },
    // 友邦HR
    'aia-hr': {
      title: '职业启航游元会',
      bg: 'https://meta.gotin.online/Table/Prod/AIA/arts/AIA_login_bg.jpg',
      bgRepeat: 'no-repeat', // 背景 fix: repeat:round 造成background-size: cover失效，图片拉伸
      id: 'aia-hr',
      logo: '',
      unionId: 'aia-hr',
      slogan: '世界',
      sloganFromLocal: 'welcomePorschetaycan',
      subTitleFromLocal: 'welcomeSubPorschetaycan',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'aia-wrap',
      // defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: false, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: false, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'simhei_aia', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextAIA'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: true, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCodePorsche'), // 短信登录标题
    },
    // 南京银行二期
    'xxx-njcb-meets': {
      title: '南京银行登录标题',
      bg: njcbMeetsBg,
      bgRepeat: 'no-repeat',
      id: 'njcb-meets',
      logo: '',
      unionId: 'njcb-meets',
      slogan: '世界',
      sloganFromLocal: 'welcomeNjcbmeets',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'njcb-meets-wrap',
      defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: true, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '点击查看南京银行', // 自己的提示内容
      OwnTipsSubTitle: '温馨提示', // 如果有提示的话，提示内容
      OwnTipsContent:
        '“你好世界”元宇宙空间是由南京银行为您打造，您注册输入的个人信息仅用于在南京银行元宇宙空间“你好世界”登录与参与活动使用，南京银行将对您的个人信息进行严格保密，不做任何其他用途，在此衷心感谢您对南京银行长期以来的关注与支持！如您需要任何帮助，请拨打南京银行统一客服热线：95302。      ', // 如果有提示的话，提示内容
      OwnMoreTips:
        '如果您已持有南京银行账户，请使用您在南京银行预留的手机号码登录。', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: false, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: '', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    takedaspark,
    cim: {
      title: i18n.t('login.loginPage.defaultTitle'), // 名称
      bg: mobileBg, // 背景图
      logo: cim,
      id: 'cim', // 唯一标识
      unionId: 'cim', // 唯一id
      slogan: 'gotin', // 宣传语
      sloganFromLocal: 'welcome',
      logoUrl: logo, // logo地址
      // logoUrl: '', // cim, // logo地址
      termsOfUse: 'https://www.gotin.online/terms', // 服务条款
      signInMethods: ['email'], // 登录方式
      signInMode: ['signIn', 'signUp'], // 注册/登录
      socialConnectors: [], // 微信登录
      languageInfo: ['en'], // 语言
      position: 'top', // 显示位置
      className: 'single-wrap',
      defaultContainer: 'box-container',
      isSupportRegion: true, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录
      isAutoLogin: false, // 是否自动登录
      hasOwnSms: false, // 是否有自己的短信服务,
      isMergeLoginAndRegister: false, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: '', // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容,
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'PorscheNextTT', // 字体名称
      agreeReadPreText: `Continuing indicates that I have read and agreed to the platform's `, // 条款前缀
      agreeAnd: i18n.t('login.register.and'), // 条款链接符
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: true, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题    }
    },
    hr: {
      title: 'hr登录标题',
      bg: porscheBg,
      id: 'porsche',
      logo: '',
      unionId: 'hr',
      slogan: '世界',
      sloganFromLocal: 'welcomePorscheHR',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'porsche-wrap porsche-hr-wrap',
      defaultContainer: 'porsche-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: false, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是都有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'PorscheNextTT', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: false, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: i18n.t('login.loginPage.sendCode'), // 短信登录标题
    },
    nissan: {
      title: 'NISSAN 尽兴e家',
      bg: nissanBg,
      id: 'nissan',
      logo: NissanLogo,
      unionId: 'nissan',
      slogan: '世界',
      sloganFromLocal: 'welcomeNissan',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'nissan-wrap',
      defaultContainer: 'nissan-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: false, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是否有自定义的登录页面
      hasFooter: false, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'HYQiHei', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: '发送', // 短信登录标题
    },
    aiahrn: {
      title: '欢迎来到 友邦易空间',
      bg: 'https://meta.gotin.online/Table/Prod/AIA/arts/AIAHRN_login_bg.jpg',
      pcBg: AiahrnPcbg,
      id: 'aiahrn',
      logo: AiahrnLogo,
      unionId: 'aiahrn',
      slogan: '世界',
      sloganFromLocal: 'welcomeAiahrn',
      // subTitleFromLocal: 'welcomeSubPorschetaycan',
      logoUrl: njcbLogo,
      termsOfUse: '',
      signInMethods: ['phone'],
      signInMode: ['signIn', 'signUp'],
      languageInfo: ['cn'],
      position: 'center',
      socialConnectors: [],
      className: 'aiahrn-wrap',
      defaultContainer: 'aiahrn-container',
      isSupportRegion: false, // 是否支持区域
      needSlientLogin: false, // 是否需要静默登录
      selfLogin: true, // 自己平台用户登录(主要是用来判断是否换取code)
      isAutoLogin: false, // 是否自动登录
      hasOwnSms: true, // 是否有自己的短信服务
      isMergeLoginAndRegister: true, // 是否合并登录/注册
      hasOwnTermsAndPrivacy: false, // 是否有自己的隐私条款
      Owndesc: i18n.t('login.register.porscheOwndesc718'), // 当前登录面板的描述
      OwnTipsTitle: '', // 自己的提示内容
      OwnTipsSubTitle: '', // 如果有提示的话，提示内容
      OwnTipsContent: '', // 如果有提示的话，提示内容
      OwnMoreTips: '', // 是否有更多提示
      isShowRegion: true, // 是否显示区域
      isNeedTagedSource: true, // 是否需要标记来源
      hasCustomLoginPage: true, // 是否有自定义的登录页面
      hasFooter: true, // 是否有底部
      hasOwnFonts: true, // 是否有自己的字体
      hasOwnThemeStyle: true, // 是否有自己的主题样式
      fontNames: 'HYQiHei', // 字体名称
      agreeReadPreText: i18n.t('login.register.readPreTextPorsche718'), // 条款前缀
      agreeAnd: i18n.t('login.register.andPorsche718'),
      isNeedPassSource: true, // 是否需要传递来源
      isNeedTitle: true, // 是否需要显示标题
      isNeedSkipGenerateAvatar: false, // 是否需要跳过生成头像
      smsTitle: '获取验证码', // 短信登录标题
    },
  }
  return MockBusinessSeetings[business] || {}
}

export const getBusinessType = () => {
  return getBusinessSeetings(getItem('business'))
}
export const getBusiness = () => getItem('business')
export const setCurrentTitle = (name) => {
  if (getBusinessSeetings(name)?.isNeedTitle) {
    document.title = getBusinessSeetings(name).title
  }
}
export const Scheme = ['/user/bind/phone', '/user/bind/email']
export const NotBindPhoneNames = ['njcb-meets']
export default gotinAddress
